const account = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M10 10a5 5 0 0 1 5 5H1a5 5 0 0 1 5-5ZM8 1c2.154 0 3.9 1.79 3.9 4S10.154 9 8 9 4.1 7.21 4.1 5 5.846 1 8 1"/></svg>',
};

export { account as default };
